module.exports = require('./build/core');
